// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__17e_T","fileBtn":"File_fileBtn__6PkX-","closeBtn":"File_closeBtn__3Cn5v","fileSelected":"File_fileSelected__yk6po","disabled":"File_disabled__1UlEk"};